import React from 'react';
import PropTypes from 'prop-types';

import { ScrollWrapper } from '../../../../ui-kit';
import { Board } from './components';
import './style.sass';

const PipeView = ({ setRef, invoiceStatuses }) => (
  <div
    className="pipe-view"
    ref={e => setRef('agendaRow', e)}
  >
    <ScrollWrapper autoHide isEasyScroll className="pipe-view__scroll-wrapper" style={{ position: 'unset' }}>
      <div
        className="pipe-view__column-wrapper"
      >
        <Board invoiceStatuses={invoiceStatuses} />
      </div>
    </ScrollWrapper>
  </div>
);

PipeView.propTypes = {
  setRef: PropTypes.func.isRequired,
  invoiceStatuses: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
};

export default PipeView;
